module.exports = __webpack_public_path__ + "img/tienda-9.1b97ebfe.png";